const AUTH_STORAGE_TOKEN_KEY = 'adminToken';

const AUTHENTICATED_API_HOSTS = new Set([
  'rv0kwp3fuc.execute-api.us-east-1.amazonaws.com',
  's9l70ztz3c.execute-api.us-east-1.amazonaws.com',
]);

const AUTH_SKIP_PATHS = new Set([
  '/default/bucks-admin-login-user',
]);

const getStoredAuthToken = () => (
  sessionStorage.getItem(AUTH_STORAGE_TOKEN_KEY)
  || localStorage.getItem(AUTH_STORAGE_TOKEN_KEY)
  || ''
);

const shouldAttachAuth = (input) => {
  if (typeof window === 'undefined') return false;

  const rawUrl = input instanceof Request ? input.url : String(input || '');
  let url;
  try {
    url = new URL(rawUrl, window.location.origin);
  } catch {
    return false;
  }

  if (!AUTHENTICATED_API_HOSTS.has(url.hostname)) return false;
  return !AUTH_SKIP_PATHS.has(url.pathname);
};

export const getApiAuthToken = getStoredAuthToken;

export const withApiAuthHeaders = (headers = {}) => {
  const nextHeaders = new Headers(headers);
  const token = getStoredAuthToken();
  const currentAuthorization = nextHeaders.get('Authorization');
  if (token && !currentAuthorization) {
    nextHeaders.set('Authorization', token);
  }
  return nextHeaders;
};

export const installApiAuthInterceptor = () => {
  if (typeof window === 'undefined' || window.__bucksApiAuthInterceptorInstalled) {
    return;
  }

  const nativeFetch = window.fetch.bind(window);

  window.fetch = (input, init = {}) => {
    if (!shouldAttachAuth(input)) {
      return nativeFetch(input, init);
    }

    const token = getStoredAuthToken();
    if (!token) {
      return nativeFetch(input, init);
    }

    const headers = new Headers(init.headers || (input instanceof Request ? input.headers : undefined));
    const currentAuthorization = headers.get('Authorization');
    if (!currentAuthorization) {
      headers.set('Authorization', token);
    }

    return nativeFetch(input, {
      ...init,
      headers,
    });
  };

  window.__bucksApiAuthInterceptorInstalled = true;
};
